export const addIsProjectFilterForProjectRoutes = (isProject, filters) => {
  if (isProject) {
    return { ...filters, isProject };
  }
  return filters;
};
